import { Typography } from "@material-ui/core";
import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const RevenueYTD = () => {
  const [revenue, setRevenue] = useState({
    series: [
      {
        name: "Ocean Transport",
        data: [300, 290, 270, 250, 230, 200, 180, 150, 200],
        color: "#66B8F7",
      },
      {
        name: "WareHouse",
        data: [300, 260, 230, 200, 230, 62, 69, 91, 148],
        color: "#FF3F38",
      },
      {
        name: "Road Transport",
        data: [10, 20, 35, 51, 49, 62, 69, 91, 148],
        color: "#47F01D",
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      yaxis: {
        min: 0,
        max: 400,
        tickAmount: 4,
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
        ],
      },
    },
  });
  return (
    <div>
      <Typography variant="h5" className="adminHomeTitle">
        Revenue YTD
      </Typography>
      <ReactApexChart
        options={revenue.options}
        series={revenue.series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default RevenueYTD;
